// import ApiService from '@/helpers/api.service';
import ApiService2 from '@/helpers/api.service.ext';

// const API = new ApiService();
const API2 = new ApiService2();

// export const state = {
//     modules: [],
//     maintenanceLogsList: [],
//     maintenanceLogsListTotal: 0,
//     maintenanceLogsPageInfo: {
//         total: 0
//     },
// }

// export const mutations = {
//     UPDATE_MAINTENANCE_MODULES(state, data){
//         state.modules = data;
//     },
//     UPDATE_MAINTENANCE_LOGS(state, data){
//         state.maintenanceLogsList = data;
//     },
//     UPDATE_MAINTENANCE_LOGS_PAGE_INFO(state, total){
//         state.maintenanceLogsListTotal = total;
//         state.maintenanceLogsPageInfo.total = total;
//     }
// }

export const actions = {
    getMaintenanceModeData(context, params){
        return new Promise((resolve, reject) => {
            API2.post(`/maintenance/get-maintenance-data`, params)
            .then(({ data }) => {
                // console.log("getMaintenanceModeData: ", data);
                // context.commit('UPDATE_MAINTENANCE_MODULES', data.message.rows);
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response);
            });
        });
    },
    updateMaintenanceModeData(context, params){
        return new Promise((resolve, reject) => {
            API2.post(`/maintenance/update-maintenance-data`, params)
            .then(({ data }) => {
              resolve(data);
            })
            .catch(({ response }) => {
              reject(response);
            });
        });
    },
    getMaintenanceModeLogs(context, params){
        return new Promise((resolve, reject) => {
            API2.post(`/maintenance/get-maintenance-data-log`, params)
            .then(({ data }) => {
            //   context.commit('UPDATE_MAINTENANCE_LOGS', data.message.rows);
            //   context.commit('UPDATE_MAINTENANCE_LOGS_PAGE_INFO', data.message.pageInfo.total);
              resolve(data);
            })
            .catch(({ response }) => {
              reject(response);
            });
        });
    },
    updateSchedMaintenanceModeData(context, params){
        return new Promise((resolve, reject) => {
            API2.post(`/maintenance/on-schedule-maintenance`, params)
            .then(({ data }) => {
              resolve(data);
            })
            .catch(({ response }) => {
              reject(response);
            });
        });
    },
    endScheduledMaintenance(context, params){
      return new Promise((resolve, reject) => {
          API2.post(`/maintenance/end-schedule-maintenance`, params)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
  },
    actionPeddlrOption(context, params) {
      return new Promise((resolve, reject) => {
        API2.post(`/maintenance/${params.action}`, params.body)
          .then(({ data }) => {
            if (data.status === "ok") {
              resolve(data)
            } else {
              reject(data.message)
            }
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    },
}